import classes from "../LocationCard.module.scss";
import React, { useContext } from "react";
import Card from "react-bootstrap/Card";
import {
  MultipleChoiceQuestion,
  MultipleChoiceResponse,
} from "@r6digital/rapidstor-types/types/Questionnaire";
import MediumHeader from "../MediumHeader";
import SmallDetail from "../SmallDetail";
import { ReactComponent as IconRightChevron } from "../../assets/icon-right-chevron.svg";
import { ReactComponent as IconHouse } from "../../assets/icon-house.svg";
import { ReactComponent as IconBusiness } from "../../assets/icon-business.svg";
import { ReactComponent as IconVehicle } from "../../assets/icon-vehicle.svg";
import QuestionnaireContext from "./QuestionnaireContext";
import { Col } from "react-bootstrap";
import { changePage } from "../../store/questionnaireSlice";
import store from "../../store";
import { useLoaderData, useNavigate } from "react-router-dom";
import Location from "../../features/rapidstor/entities/Location";

interface Props {
  question: MultipleChoiceQuestion;
  response: MultipleChoiceResponse;
  selected?: boolean;
  onSelect?: (answer: string | boolean | number) => void;
}

function getIcon(name?: string): React.ReactNode | undefined {
  if (!name) {
    return undefined;
  }
  return {
    "fa-house": <IconHouse className={classes.icon} />,
    "fa-briefcase": <IconBusiness className={classes.icon} />,
    "fa-car": <IconVehicle className={classes.icon} />,
  }[name];
}

function MultipleChoiceResponseCard({
  question,
  response,
  selected = false,
  onSelect,
}: Props) {
  const location = useLoaderData() as Location;
  const navigate = useNavigate();
  const icon = getIcon(response.icon);

  const { questionnaire } = useContext(QuestionnaireContext);

  const onClick = () => {
    if (onSelect) {
      onSelect(response.answer);
    }
    if (response.actions) {
      for (const action of response.actions) {
        if (action.type === "go-to-page" && questionnaire) {
          if (action.page) {
            store.dispatch(changePage(questionnaire.pages[action.page]));
          } else if (action.last) {
            navigate(`/locations/${location.slug}/units`);
          }
        }
      }
    }
  };

  const expanded = question.appearance === "expanded";
  const cardClasses = [
    classes.card,
    classes.response,
    selected && classes.selected,
    expanded && classes.expanded,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Col xs={expanded ? 12 : 6} lg={expanded ? 6 : 4}>
      <Card className={cardClasses} onClick={onClick}>
        <Card.Body className={classes.cardBody}>
          {icon && icon}
          <div className={classes.facilityInfo}>
            <MediumHeader className={classes.name}>{response.answer}</MediumHeader>
            <SmallDetail className={classes.responseDescription}>
              {response.description}
            </SmallDetail>
          </div>
          {question.appearance === "expanded" && (
            <IconRightChevron className={`flex-shrink-0 ${classes.arrow}`} />
          )}
        </Card.Body>
      </Card>
    </Col>
  );
}

export default MultipleChoiceResponseCard;
